import StepProgress from "@/components/booking/StepProgress";

const STEPS = [1, 2, 3];

export default function BookingHeader({ t, step, totalSteps, label }) {
  return (
    <div className="flex items-center justify-between mb-8">
      <div>
        <span className="label-eyebrow">
          {t.booking.step} {step} {t.booking.of} {totalSteps}
        </span>
        <div className="font-heading text-2xl sm:text-3xl mt-1">{label}</div>
      </div>
      <StepProgress steps={STEPS} current={step} />
    </div>
  );
}
